export default __webpack_public_path__ + "static/media/1.bb49a745.svg";